import { http } from 'utils'

import { creditAllocationTxServiceTypes } from 'types/creditAllocationTxTypes'
import { creditAllocationRefundTxServiceTypes } from 'types/creditAllocationRefundTxTypes'
import { specialIcashRefundTxServiceTypes } from 'types/specialIcashRefundTxTypes'

export async function creditAllocationAPI({
  creditValue,
  externalTransactionId,
  ident,
  cashier,
  guid,
  transactionDate,
  storeId,
  comments,
  traceNumber,
  reasonId,
  pin,
}: creditAllocationTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/credit-allocation'
  const data = {
    creditValue,
    externalTransactionId,
    ident,
    cashier,
    guid,
    transactionDate,
    storeId,
    comments,
    traceNumber,
    reasonId,
    pin,
  }
  return await http.post(url, data)
}

export async function creditAllocationRefundAPI({
  creditValue,
  externalTransactionId,
  ident,
  storeId,
  cashier,
  guid,
  transactionDate,
  comments,
  traceNumber,
  reasonId,
  pin,
}: creditAllocationRefundTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/credit-allocation-refund'
  const data = {
    creditValue,
    externalTransactionId,
    ident,
    storeId,
    cashier,
    guid,
    transactionDate,
    comments,
    traceNumber,
    reasonId,
    pin,
  }
  return await http.post(url, data)
}

export async function specialIcashRefundAPI({
  creditValue,
  externalTransactionId,
  ident,
  storeId,
  cashier,
  guid,
  comments,
  traceNumber,
  reasonId,
}: specialIcashRefundTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/special-icash-refund'
  const data = {
    creditValue,
    externalTransactionId,
    ident,
    cashier,
    guid,
    comments,
    traceNumber,
    reasonId,
    storeId,
  }
  return await http.post(url, data)
}